import { QueryClient } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            cacheTime: 1000 * 60 * 60, // 60 minutes
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
                if (error?.response?.status && [401, 403, 404].includes(error.response.status)) {
                    return false;
                }

                return failureCount < 3;
            },
        },
    },
});

export default { queryClient };
